import React from 'react';
import {
    CSpinner,
    CInputGroup,
    CInputGroupText,
    CCardHeader,
    CInputRadio,
    CInputCheckbox,
    CCard,
    CTextarea,
    CCardBody,
    CCol,
    CRow,
    CButton,
    CModal,
    CModalHeader,
    CCardFooter,
    CModalTitle,
    CModalBody,
    CModalFooter,
    CProgress,
    CBadge,
    CFormGroup,
    CLabel,
    CInput,
    CInputFile,
    CSelect,
} from '@coreui/react';
import {
    FaUserFriends,
    FaCheckCircle,
    FaUserPlus,
    FaBriefcase,
    FaFileAlt,
    FaPauseCircle,
    FaUserTie,
    FaTimesCircle,
    FaFolderOpen,
    FaSearch,
    FaCamera,    // Add this
    FaTrash,     // Add this
    FaEye,       // Add this
    FaPlus,

} from 'react-icons/fa';
import CIcon from '@coreui/icons-react';
import { connect } from "react-redux";
import './JobListing.css';
import "./Appoinment.css";
import ReactQuill from 'react-quill';
import 'react-quill/dist/quill.snow.css';
import '../../assets/css/UnifiedUIChanges.css';
import Select from 'react-select';
import { imgurl } from 'src/actions/types'; // For 'imgurl' is not defined
import salaryperson from "../../assets/images/user.jpg"; // For 'salaryperson' is not defined

import editw from '../../assets/images/editw.png';
import trashw from '../../assets/images/trashw.png';

import {
    getHRRecruitmentMain,
    getHRRecruitmentCandidate,
    getHRRecruitmentInfo,
    createHRRecruitmentCandidate,
    updateHRRecruitmentCandidate,
    createHRRecruitmentCandidateResume,
    updateHRRecruitmentCandidateResume,
    getHRRecruitmentCandidateResume,
    deleteHRRecruitmentCandidateResume,
    updateHRRecruitmentInfo,
    createHRRecruitmentInfo,
    deleteHRRecruitmentInfo,
    createHRRecruitmentSurveyResponse,
    getHRStaff,
    SendHREmail,
    SendSMS,
    createHREmail,
    createHRRecruitmentCandidateEmail,
} from "../../actions/setuphrstaffbasicinformationAction";
import { getsetupHrSurveyTemplate, getsetupHrTemplate } from "../../actions/setuphospitalehrsettingAction";
import GlobalLoader from './GlobalLoader';
import './RecruitmentDashboard.css';
import {
    getEmail,
    getNotification,
} from "../../actions/setupsettingAction";
import { getUser } from "../../actions/loginAction";
import close from '../../assets/images/close.png'



const fontWhitelist = ['arial', 'comic-sans', 'courier-new', 'georgia', 'helvetica', 'lucida'];
const Font = ReactQuill.Quill.import('formats/font');
Font.whitelist = fontWhitelist;
ReactQuill.Quill.register(Font, true);

const quillModules = {
    toolbar: [
        [{ 'header': [1, 2, 3, 4, 5, 6, false] }],
        [{ 'font': fontWhitelist }],
        ['bold', 'italic', 'underline', 'strike', 'blockquote'],
        [{ 'list': 'ordered' }, { 'list': 'bullet' }],
        ['link',],
        [{ 'align': [] }],
        [{ 'color': [] }, { 'background': [] }],
        ['clean']
    ],
};

const quillFormats = [
    'header', 'font', 'bold', 'italic', 'underline', 'strike', 'blockquote',
    'list', 'bullet', 'indent', 'link', 'align', 'color', 'background'
];


class JobListing extends React.Component {
    constructor() {
        super();
        this.state = {
            phoneValidationError: "",
            emailValidationError: "",
            embedModal: false,

            loadingMessage: 'Processing...',
            isLoading: true,

            searchQuery: "",
            confirmationModal: false,
            existingApplicationInfo: null,
            detailsModal: false,
            applyModal: false,
            surveyModal: false,

            selectedJob: null,

            newCandidate: {
                name: "",
                email: "",
                phone: "",
                dob: "",
                gender: "",
                status: "Active",
                profilePhotoFile: null,
                resumeFile: null,
                Source: "",
                Referral: "",
            },
            messageAlert: false,
            message: "",
        };
    }

    getHospitalId = () => {
        if (this.props.match && this.props.match.params && this.props.match.params.hid) {
            const compositeParam = this.props.match.params.hid.toString();
            if (compositeParam.length > 18) {
                return compositeParam.slice(0, compositeParam.length - 18);
            }

            return compositeParam;
        }
        return localStorage.getItem("hospitalCode")?.toString();
    }

    componentDidMount() {
        const hid = this.getHospitalId();
        if (hid) {
            const hidPayload = JSON.stringify({ hid: hid });
            this.props.getUser(JSON.stringify({ hospitalID: hid }));
            this.props.getsetupHrSurveyTemplate(hidPayload);
            this.refreshRecruitmentList();
        }
        else {
            console.warn("No Hospital ID found on mount.");
            this.setState({ isLoading: false });
        }
    }

    refreshRecruitmentList = async () => {
        const hid = this.getHospitalId();
        if (!hid) {
            console.error("Hospital ID (hid) is missing. Cannot fetch recruitment list.");
            this.setState({ isLoading: false });
            return;
        }

        this.setState({ isLoading: true });
        try {
            const hospitalIdPayload = JSON.stringify({ hid: hid });
            const notificationData = JSON.stringify({ hospitalID: hid });

            await Promise.all([
                this.props.getEmail(hospitalIdPayload),
                this.props.getNotification(notificationData),
                this.props.getHRStaff(hospitalIdPayload),
                this.props.getHRRecruitmentCandidateResume(hospitalIdPayload),
                this.props.getHRRecruitmentInfo(hospitalIdPayload),
                this.props.getHRRecruitmentCandidate(hospitalIdPayload),
                this.props.getHRRecruitmentMain(hospitalIdPayload),
                this.props.getsetupHrTemplate(hospitalIdPayload)
            ]);

        } catch (error) {
            console.error("Failed to refresh data:", error);
        } finally {
            this.setState({ isLoading: false });
        }
    }

    handleSearchChange = (event) => {
        this.setState({ searchQuery: event.target.value });
    }

    toggleDetailsModal = (job = null) => {
        this.setState(prevState => ({ detailsModal: !prevState.detailsModal, selectedJob: job }));
        this.refreshRecruitmentList()
    }

    toggleApplyModal = (job = null) => {
        this.setState(prevState => ({
            applyModal: !prevState.applyModal,
            selectedJob: job,
            phoneValidationError: "",
            emailValidationError: ""
        }));
        if (!job) {
            this.setState({
                newCandidate: { name: "", email: "", phone: "", dob: "", gender: "", status: "Active", profilePhotoFile: null, resumeFile: null, Source: "", Referral: "" }
            });
        }
        this.refreshRecruitmentList();
    }

    handleInputChange = (field, value) => {
        this.setState(prevState => ({
            newCandidate: { ...prevState.newCandidate, [field]: value }
        }));
    };

    handleFileChange = (field, file, event) => {
        if (!file) return;

        const cleanName = file.name
            .trim()
            .replace(/\s+/g, "")
            .replace(/[^a-zA-Z0-9._-]/g, "");

        const sanitizedFile = new File([file], cleanName, { type: file.type });
        const fileName = sanitizedFile.name.toLowerCase();

        if (field === 'resumeFile') {
            const allowedExtensions = [".jpeg", ".jpg", ".png", ".gif", ".pdf", ".doc", ".docx", ".xls", ".xlsx", ".csv"];
            const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

            if (!hasValidExtension) {
                this.setState({
                    messageAlert: true,
                    message: "Invalid file type. Allowed formats for Resume: .jpeg, .jpg, .png, .gif, .pdf, .doc, .docx, .xls, .xlsx, .csv"
                });
                if (event && event.target) {
                    event.target.value = "";
                }
                return;
            }
        }

        if (field === 'profilePhotoFile') {
            const allowedExtensions = [".jpg", ".png", ".jpeg"];
            const hasValidExtension = allowedExtensions.some(ext => fileName.endsWith(ext));

            if (!hasValidExtension) {
                this.setState({
                    messageAlert: true,
                    message: "Invalid file type. Allowed formats for Profile Photo: .jpg, .png, .jpeg"
                });
                if (event && event.target) {
                    event.target.value = "";
                }
                return;
            }
        }

        this.setState(prevState => ({
            newCandidate: { ...prevState.newCandidate, [field]: sanitizedFile }
        }));
    }

    handleApplySubmit = async (openMailAfter = false) => {
        const { newCandidate, selectedJob, phoneValidationError, emailValidationError } = this.state;
        const { HRRecruitmentCandidateList, HRRecruitmentInfoList, HRRecruitmentMainList } = this.props;
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/;

        if (!newCandidate.name || !newCandidate.email || !newCandidate.phone || !newCandidate.dob || !newCandidate.resumeFile || !newCandidate.Source || !newCandidate.Referral || !newCandidate.gender) {
            this.setState({ messageAlert: true, message: "Please fill all required (*) fields and upload a resume." });
            return;
        }
        if (phoneValidationError || emailValidationError) {
            this.setState({ messageAlert: true, message: "Please resolve duplicate validation errors before submitting." });
            return;
        }
        if (!emailRegex.test(newCandidate.email)) {
            this.setState({ messageAlert: true, message: "Please enter a valid email address." });
            return;
        }

        if (!phoneRegex.test(newCandidate.phone)) {
            this.setState({ messageAlert: true, message: "Invalid phone number. Please enter exactly 10 digits." });
            return;
        }

        const hid = this.getHospitalId();
        const existingCandidate = (HRRecruitmentCandidateList || []).find(c => c.Phone === newCandidate.phone && c.hid === hid);

        if (existingCandidate) {
            const allInfoEntriesForCandidate = (HRRecruitmentInfoList || []).filter(info =>
                info.cid.toString() === existingCandidate.id.toString() && info.hid === hid
            );

            for (const info of allInfoEntriesForCandidate) {
                if (info.Reqid.toString() !== selectedJob.id.toString()) {
                    const otherProcess = (HRRecruitmentMainList || []).find(main =>
                        main.id.toString() === info.Reqid.toString() &&
                        (main.Status === 'Open' || main.Status === 'On Hold') &&
                        main.hid === hid
                    );

                    if (otherProcess) {
                        this.setState({
                            confirmationModal: true,
                            existingApplicationInfo: {
                                ...info,
                                roleTitle: otherProcess.Title,
                            }
                        });
                        return;
                    }
                }
            }
        }

        this.submitApplicationFlow(openMailAfter);
    };

    handleSubmitAndMail = () => {
        this.handleApplySubmit(true);
    }

    submitApplicationFlow = async (openMailAfter = false) => {
        this.setState({ isLoading: true, applyModal: false });
        const { newCandidate, selectedJob } = this.state;
        const { HRRecruitmentCandidateList, HRRecruitmentInfoList, HRRecruitmentCandidateResumeList } = this.props;
        const hid = this.getHospitalId();

        try {
            let candidateId;
            const existingCandidate = (HRRecruitmentCandidateList || []).find(c => c.Phone === newCandidate.phone && c.hid === hid);

            if (existingCandidate) {
                const candidateData = new FormData();
                candidateData.append('id', existingCandidate.id);
                candidateData.append('Name', newCandidate.name || "");
                candidateData.append('email', newCandidate.email || "");
                candidateData.append('Phone', newCandidate.phone || "");
                candidateData.append('DOB', newCandidate.dob || "");
                candidateData.append('gender', newCandidate.gender || "");
                candidateData.append('Status', 'Active');
                candidateData.append('hid', hid);
                if (newCandidate.profilePhotoFile) candidateData.append('ProfilePhoto', newCandidate.profilePhotoFile);
                await this.props.updateHRRecruitmentCandidate(candidateData);
                candidateId = existingCandidate.id;
            } else {
                const candidateData = new FormData();
                candidateData.append('Name', newCandidate.name || "");
                candidateData.append('email', newCandidate.email || "");
                candidateData.append('Phone', newCandidate.phone || "");
                candidateData.append('DOB', newCandidate.dob || "");
                candidateData.append('gender', newCandidate.gender || "");
                candidateData.append('Status', 'Active');
                candidateData.append('hid', hid);
                if (newCandidate.profilePhotoFile) candidateData.append('ProfilePhoto', newCandidate.profilePhotoFile);

                const newlyCreatedCandidate = await this.props.createHRRecruitmentCandidate(candidateData);
                if (newlyCreatedCandidate && newlyCreatedCandidate.id) {
                    candidateId = newlyCreatedCandidate.id;
                } else {
                    throw new Error("Failed to create candidate record.");
                }
            }

            if (!candidateId) throw new Error("Candidate ID is missing.");
            await this.props.getHRRecruitmentCandidate(JSON.stringify({ hid: hid }));

            const existingResume = (HRRecruitmentCandidateResumeList || []).find(
                r => r.cid.toString() === candidateId.toString() && r.Reqid.toString() === selectedJob.id.toString() && r.hid === hid
            );
            if (existingResume) {
                await this.props.deleteHRRecruitmentCandidateResume(JSON.stringify({ id: existingResume.id, hid }));
            }
            const resumeFormData = new FormData();
            resumeFormData.append('cid', candidateId.toString());
            resumeFormData.append('DocType', 'Resume');
            resumeFormData.append('Document', newCandidate.resumeFile);
            resumeFormData.append('Reqid', selectedJob.id);
            resumeFormData.append('hid', hid);
            await this.props.createHRRecruitmentCandidateResume(resumeFormData);

            const existingInfo = (HRRecruitmentInfoList || []).find(
                i => i.cid.toString() === candidateId.toString() && i.Reqid.toString() === selectedJob.id.toString() && i.hid === hid
            );

            const infoPayload = {
                "cid": candidateId.toString(),
                "history_id": 0,
                "Recruitment": selectedJob.Title || "",
                "currentStage": "Applied",
                "Department": selectedJob.Department || "",
                "JobPosition": selectedJob.JobPosition || "",
                "Reqid": selectedJob.id.toString(),
                "Source": newCandidate.Source || "",
                "Referral": newCandidate.Referral || "",
                "Rdate": new Date().toISOString().split('T')[0],
                "Rtime": new Date().toTimeString().split(' ')[0].substring(0, 5),
                "DateOfJoining": "",
                "ProbationEndDate": "",
                "OfferLetterStatus": "Pending",
                "DateOfExit": null,
                "OffboardingStatus": null,
                "hid": hid
            };
            if (existingInfo) {
                infoPayload.id = existingInfo.id;
                await this.props.updateHRRecruitmentInfo(JSON.stringify(infoPayload));
            } else {
                await this.props.createHRRecruitmentInfo(JSON.stringify(infoPayload));
            }

            const candidateDataObj = {
                id: candidateId,
                Name: newCandidate.name,
                email: newCandidate.email,
                Phone: newCandidate.phone
            };

            await this.processAutomatedEmail(candidateDataObj, selectedJob);

            if (selectedJob.SurveyTemp) {
                this.setState({ isLoading: false, applyModal: false });
                this.handleSurveyStart(candidateId, selectedJob);
            } else {
                this.setState({ isLoading: false, applyModal: false, messageAlert: true, message: "Application submitted successfully!" });
            }

        } catch (error) {
            console.error("Error submitting application:", error);
            this.setState({ isLoading: false, messageAlert: true, message: "An error occurred. Please try again." });
        }
    };

    handleProceedWithNewApplication = async () => {
        const { existingApplicationInfo } = this.state;
        const { HRRecruitmentCandidateResumeList } = this.props;
        const hid = this.getHospitalId();

        this.setState({ isLoading: true });
        try {
            const oldResume = (HRRecruitmentCandidateResumeList || []).find(r =>
                r.cid.toString() === existingApplicationInfo.cid.toString() &&
                r.Reqid.toString() === existingApplicationInfo.Reqid.toString() &&
                r.hid === hid
            );
            if (oldResume) {
                await this.props.deleteHRRecruitmentCandidateResume(JSON.stringify({ id: oldResume.id, hid }));
            }
            await this.props.deleteHRRecruitmentInfo(JSON.stringify({ id: existingApplicationInfo.id, hid }));

            this.setState({ confirmationModal: false, existingApplicationInfo: null });
            await this.submitApplicationFlow();

        } catch (error) {
            console.error("Error withdrawing old application:", error);
            this.setState({ isLoading: false, messageAlert: true, message: "An error occurred while withdrawing the previous application. Please try again." });
        }
    };


    renderDetailsModal() {
        const { detailsModal, selectedJob } = this.state;
        if (!selectedJob) return null;

        const dateStatus = this.getJobDateStatus(selectedJob);

        let finalStatus = 'active';
        if (selectedJob.Status === 'On Hold') {
            finalStatus = 'on_hold';
        } else if (selectedJob.Status === 'Closed') {
            finalStatus = 'expired';
        } else {
            finalStatus = dateStatus;
        }

        const isApplyDisabled = finalStatus !== 'active';
        let buttonText = "Apply Now";
        let buttonColor = "primary";
        let badge = null;

        if (finalStatus === 'on_hold') {
            buttonText = "On Hold";
            buttonColor = "warning";
            badge = <CBadge color="warning" className="ml-2">On Hold</CBadge>;
        } else if (finalStatus === 'expired') {
            buttonText = "Job Closed";
            buttonColor = "secondary";
            badge = <CBadge color="danger" className="ml-2">Expired</CBadge>;
        } else if (finalStatus === 'upcoming') {
            buttonText = "Opens Soon";
            buttonColor = "info";
            badge = <CBadge color="info" className="ml-2">Upcoming</CBadge>;
        }

        return (
            <CModal className="drawer-modal" show={detailsModal}
                backdrop={false}
                closeOnBackdrop={false} onClose={() => this.toggleDetailsModal()} size="lg">
                <CModalHeader closeButton className={"custom-modal-header"} >
                    <CModalTitle>{selectedJob.Title}
                        {badge}
                    </CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <h5>{selectedJob.JobPosition}</h5>
                    <p className="text-muted">{selectedJob.Company}</p>
                    <hr />
                    <h6>Job Description</h6>
                    <p>{selectedJob.Description || 'No detailed description available.'}</p>
                    <hr />
                    <CRow>
                        <CCol md="6">
                            <p><strong>Manager:</strong> {selectedJob.Manager || 'N/A'}</p>
                            <p><strong>Vacancy:</strong> {selectedJob.Vacancy}</p>
                        </CCol>
                        <CCol md="6">
                            <p><strong>Start Date:</strong> {new Date(selectedJob.StartDate).toLocaleDateString()}</p>
                            <p><strong>End Date:</strong> {new Date(selectedJob.EndDate).toLocaleDateString()}</p>
                        </CCol>
                    </CRow>
                </CModalBody>
                <CModalFooter className="custom-modal-footer">
                    <CButton color="secondary" onClick={() => this.toggleDetailsModal()}>Close</CButton>
                    <CButton className={"btn-success-custom"}
                        disabled={isApplyDisabled}
                        onClick={() => { this.toggleDetailsModal(); this.toggleApplyModal(selectedJob); }}>
                        {buttonText}
                    </CButton>
                </CModalFooter>
            </CModal>
        );
    }

    renderApplyModal() {
        const { applyModal, selectedJob, newCandidate } = this.state;
        if (!selectedJob) return null;
        const today = new Date().toISOString().split('T')[0];
        const emailRegex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        const phoneRegex = /^\d{10}$/;

        const isEmailInvalid = newCandidate.email && !emailRegex.test(newCandidate.email);
        const isPhoneInvalid = newCandidate.phone && !phoneRegex.test(newCandidate.phone);

        return (
            <CModal show={applyModal} className="drawer-modal" onClose={() => this.toggleApplyModal()}
                backdrop={false}
                closeOnBackdrop={false} size="lg">
                <CModalHeader closeButton className="custom-modal-header">
                    <CModalTitle>Apply for {selectedJob.JobPosition}</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    {/* --- OPTION 3: COMPACT SINGLE ROW LAYOUT --- */}
                    <div className="force-single-row mt-2">
                        {/* LEFT: PHOTO SECTION */}
                        <div className="photo-col-compact">
                            <img
                                src={newCandidate.profilePhotoFile ? URL.createObjectURL(newCandidate.profilePhotoFile) : (newCandidate.profilePhotoUrl ? `${imgurl}${newCandidate.profilePhotoUrl}` : salaryperson)}
                                className="avatar-mini shadow-sm"
                                style={{ width: '48px', height: '48px', borderRadius: '50%', objectFit: 'cover', marginRight: '12px', border: '1px solid #d8dbe0', cursor: 'pointer' }}
                                alt="Profile"
                                onError={(e) => { e.target.src = salaryperson; }}
                                title="Click to view"
                                onClick={() => {
                                    const url = newCandidate.profilePhotoFile ? URL.createObjectURL(newCandidate.profilePhotoFile) : (newCandidate.profilePhotoUrl ? `${imgurl}${newCandidate.profilePhotoUrl}` : null);
                                    if (url) window.open(url, '_blank');
                                }}
                            />
                            <div>
                                <CLabel className=" mb-0" style={{ fontSize: '14px' }}>Profile Photo </CLabel>
                                <div className="d-flex align-items-center mt-1">
                                    <label className="upload-border-btn mb-0" style={{ fontSize: '12px', padding: '2px 8px', border: '1px solid #321fdb', borderRadius: '4px', color: '#321fdb', cursor: 'pointer', fontWeight: 'bold' }}>
                                        <FaPlus size={10} className="mr-1" /> Browse
                                        <input type="file" hidden accept="image/*" onChange={(e) => this.handleFileChange('profilePhotoFile', e.target.files[0], e)} />
                                    </label>

                                    <button
                                        className="remove-text-link"
                                        style={{
                                            fontSize: '12px', marginLeft: '5px', background: 'none', border: 'none', padding: 0,
                                            cursor: !(newCandidate.profilePhotoFile || newCandidate.profilePhotoUrl) ? 'not-allowed' : 'pointer',
                                            opacity: !(newCandidate.profilePhotoFile || newCandidate.profilePhotoUrl) ? 0.3 : 1,
                                            filter: !(newCandidate.profilePhotoFile || newCandidate.profilePhotoUrl) ? 'grayscale(1)' : 'none'
                                        }}
                                        type="button"
                                        disabled={!(newCandidate.profilePhotoFile || newCandidate.profilePhotoUrl)}
                                        onClick={() => {
                                            this.handleInputChange('profilePhotoFile', null);
                                            if (this.state.newCandidate.profilePhotoUrl) { this.handleInputChange('profilePhotoUrl', ""); }
                                        }}
                                    >
                                        <img src={trashw} alt="delete" width="15" height="15" style={{ filter: 'invert(21%) sepia(90%) saturate(4975%) hue-rotate(352deg) brightness(91%) contrast(106%)' }} />
                                    </button>
                                </div>
                                <div style={{ fontSize: '10px', color: '#8a93a2' }}>JPG, PNG...</div>
                            </div>
                        </div>

                        {/* RIGHT: RESUME SECTION */}
                        <div className="resume-col-compact">
                            <CLabel className=" mb-0" style={{ fontSize: '14px' }}>Resume / CV <span className="text-danger">*</span></CLabel>
                            <div className="chip-input-group shadow-sm mt-1">
                                <FaFileAlt className="text-muted mr-1" size={12} />
                                <div
                                    style={{ fontSize: '13px', flex: 1, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', color: '#4f5d73', cursor: 'pointer' }}
                                    title="Click to view"
                                    onClick={() => {
                                        const resumeUrl = newCandidate.resumeFile ? URL.createObjectURL(newCandidate.resumeFile) : (newCandidate.resumeUrl ? `${imgurl}${newCandidate.resumeUrl}` : null);
                                        if (resumeUrl) window.open(resumeUrl, '_blank');
                                    }}
                                >
                                    {newCandidate.resumeFile ? newCandidate.resumeFile.name : (newCandidate.resumeUrl ? "Current_Resume.pdf" : "No file chosen")}
                                </div>

                                <label className="browse-text-btn mb-0" style={{ fontSize: '12px', borderLeft: '1px solid #d8dbe0', padding: '0 10px', color: '#321fdb', cursor: 'pointer', fontWeight: 'bold', height: '100%', display: 'flex', alignItems: 'center', background: '#f8f9fa' }}>
                                    Browse
                                    <input type="file" hidden onChange={(e) => this.handleFileChange('resumeFile', e.target.files[0], e)} />
                                </label>

                                <div
                                    className="trash-btn-fixed"
                                    style={{
                                        borderLeft: '1px solid #d8dbe0', padding: '0 8px', display: 'flex', alignItems: 'center',
                                        cursor: !(newCandidate.resumeFile || newCandidate.resumeUrl) ? 'not-allowed' : 'pointer',
                                        opacity: !(newCandidate.resumeFile || newCandidate.resumeUrl) ? 0.3 : 1,
                                        filter: !(newCandidate.resumeFile || newCandidate.resumeUrl) ? 'grayscale(1)' : 'none'
                                    }}
                                    onClick={() => this.handleInputChange('resumeFile', null)}
                                >
                                    <img src={trashw} alt="delete" width="15" height="15" style={{ filter: 'invert(21%) sepia(90%) saturate(4975%) hue-rotate(352deg) brightness(91%) contrast(106%)' }} />
                                </div>
                            </div>
                        </div>
                    </div>
                    <CRow className="mt-3">
                        <CCol md="6"><CFormGroup><CLabel>Full Name <span className="text-danger">*</span></CLabel><CInput value={newCandidate.name} onChange={(e) => this.handleInputChange('name', e.target.value)} /></CFormGroup></CCol>

                        <CCol md="6">
                            <CFormGroup>
                                <CLabel>Email <span className="text-danger">*</span></CLabel>
                                <CInput
                                    type="email"
                                    style={isEmailInvalid || this.state.emailValidationError ? { borderColor: 'red' } : {}}
                                    value={newCandidate.email}
                                    onChange={this.handleEmailChange}
                                    invalid={!!this.state.emailValidationError}
                                />
                                {this.state.emailValidationError && (
                                    <div className="text-danger mt-1 small" style={{ fontSize: '0.8rem', fontWeight: '500' }}>
                                        {this.state.emailValidationError}
                                    </div>
                                )}
                            </CFormGroup>
                        </CCol>

                        <CCol md="6">
                            <CFormGroup>
                                <CLabel>Phone <span className="text-danger">*</span></CLabel>
                                <CInput
                                    type="text"
                                    placeholder="10 digit mobile"
                                    style={isPhoneInvalid || this.state.phoneValidationError ? { borderColor: 'red' } : {}}
                                    value={newCandidate.phone}
                                    onChange={this.handlePhoneChange}
                                    invalid={!!this.state.phoneValidationError}
                                />
                                {this.state.phoneValidationError && (
                                    <div className="text-danger mt-1 small" style={{ fontSize: '0.8rem', fontWeight: '500' }}>
                                        {this.state.phoneValidationError}
                                    </div>
                                )}
                            </CFormGroup>
                        </CCol>
                        <CCol md="6"><CFormGroup><CLabel>Date of Birth <span className="text-danger">*</span></CLabel>
                            <CInput
                                type="date"
                                max={today}
                                value={newCandidate.dob}
                                onChange={(e) => this.handleInputChange('dob', e.target.value)}
                            />
                        </CFormGroup></CCol>
                        <CCol md="6"><CFormGroup><CLabel>Gender<span className="text-danger">*</span></CLabel><CSelect custom value={newCandidate.gender} onChange={(e) => this.handleInputChange('gender', e.target.value)}><option value="">Select Gender</option><option value="Male">Male</option><option value="Female">Female</option><option value="Other">Other</option></CSelect></CFormGroup></CCol>
                        <CCol md="6"><CFormGroup><CLabel>How did you hear about us? (Source)<span className="text-danger">*</span></CLabel><CInput placeholder="e.g., LinkedIn, Company Website" value={newCandidate.Source} onChange={(e) => this.handleInputChange('Source', e.target.value)} /></CFormGroup></CCol>
                        <CCol md="12"><CFormGroup><CLabel>Referral<span className="text-danger">*</span></CLabel><CInput placeholder="If someone referred you, please enter their name" value={newCandidate.Referral} onChange={(e) => this.handleInputChange('Referral', e.target.value)} /></CFormGroup></CCol>


                    </CRow>
                </CModalBody>
                <CModalFooter className="custom-modal-footer">
                    <CButton color="secondary" onClick={this.toggleApplyModal}>Cancel</CButton>
                    {/* <CButton className={"btn-success-custom"} onClick={this.handleSaveOrUpdateCandidate}>Save</CButton> */}
                    <CButton className={"btn-success-custom"} onClick={() => this.handleApplySubmit(false)}>Submit Application</CButton>

                </CModalFooter>
            </CModal>
        );
    }


    handleSurveyStart = (candidateId, job) => {
        const { setupHRSurveyTemplateList } = this.props;
        const questions = (setupHRSurveyTemplateList || []).filter(q => q.Title === job.SurveyTemp);

        if (questions.length > 0) {
            this.setState({
                surveyQuestions: questions,
                candidateIdForSurvey: candidateId,
                selectedJobForSurvey: job,
                stageForSurvey: {
                    id: job.currentStage || 0,
                    Reqid: job.id
                },
                currentQuestionIndex: 0,
                candidateAnswers: {},
                surveyModal: true,
                viewProfileModal: false
            });
        } else {
            this.setState({
                applyModal: false,
                messageAlert: true,
                message: "Application submitted successfully! We will get back to you shortly."
            });
        }
    };

    handleAnswerChange = (questionId, questionType, value) => {
        this.setState(prevState => {
            const currentAnswers = { ...prevState.candidateAnswers };
            if (questionType === 'checkbox') {
                const existingAnswers = currentAnswers[questionId] || [];
                const newAnswers = existingAnswers.includes(value)
                    ? existingAnswers.filter(ans => ans !== value)
                    : [...existingAnswers, value];
                currentAnswers[questionId] = newAnswers;
            } else {
                currentAnswers[questionId] = value;
            }
            return { candidateAnswers: currentAnswers };
        });
    };

    handleNextQuestion = () => {
        this.setState(prevState => ({ currentQuestionIndex: prevState.currentQuestionIndex + 1 }));
    };

    handlePrevQuestion = () => {
        this.setState(prevState => ({ currentQuestionIndex: prevState.currentQuestionIndex - 1 }));
    };

    handleFinishSurvey = async () => {
        this.setState({ isLoading: true, surveyModal: false });
        const { surveyQuestions, candidateAnswers, candidateIdForSurvey, selectedJob } = this.state;
        const hid = this.getHospitalId();

        try {
            if (!selectedJob || !selectedJob.id) {
                console.error("Cannot finish survey, selectedJob is invalid.", selectedJob);
                this.setState({
                    surveyModal: false,
                    messageAlert: true,
                    message: "An error occurred. Could not find the job associated with this survey. Please try again."
                });
                return;
            }

            const responsePromises = surveyQuestions.map(question => {
                const userInput = candidateAnswers[question.id] || (question.OptionTypes === 'checkbox' ? [] : "");

                const payload = {
                    cid: candidateIdForSurvey,
                    Reqid: selectedJob.id,
                    StageId: 0,
                    SurveyTitle: question.Title,
                    SurveyId: question.id,
                    OptionsType: question.OptionTypes,
                    QuestionID: question.id,
                    QuestionText: question.Question,
                    UserInput: Array.isArray(userInput) ? JSON.stringify(userInput) : userInput,
                    hid: hid,
                };
                return this.props.createHRRecruitmentSurveyResponse(JSON.stringify(payload));
            });

            await Promise.all(responsePromises);
            await this.props.getHRRecruitmentCandidate(JSON.stringify({ hid: hid }));

            this.setState({
                isLoading: false,
                surveyModal: false,
                messageAlert: true,
                message: "Thank you! Your application has been successfully submitted."
            });
        } catch (error) {
            console.error("Error submitting survey:", error);
            this.setState({
                isLoading: false,
                surveyModal: false,
                messageAlert: true,
                message: "An error occurred while submitting the survey. Please try again."
            });
        }
    };

    renderSurveyModal() {
        const { surveyModal, surveyQuestions, currentQuestionIndex, candidateAnswers } = this.state;
        if (!surveyModal || surveyQuestions.length === 0) return null;

        const currentQuestion = surveyQuestions[currentQuestionIndex];
        const options = currentQuestion.Options
            ? currentQuestion.Options.split(';').map(opt => {
                const trimmedOpt = opt.trim();
                const match = trimmedOpt.match(/^[a-zA-Z0-9]\)\s*(.*)/);
                return match ? match[1].trim() : trimmedOpt;
            }).filter(opt => opt)
            : [];

        return (
            <CModal
                show={surveyModal}
                className="drawer-modal"
                closeOnBackdrop={false}
                backdrop={false}
                onClose={() => { this.setState({ surveyModal: false }); this.refreshRecruitmentList(); }}
                size="lg"
            >
                <CModalHeader
                    closeButton
                    // style={{ backgroundColor: '#303c54f3', color: 'white' }}
                    className="border-0 custom-modal-header"
                >
                    <CModalTitle
                        className=" h5 font-weight-bold custom-modal-title"
                    >
                        {currentQuestion.Title}
                    </CModalTitle>
                </CModalHeader>

                <CModalBody className="survey-body">
                    <div className="mb-3">
                        <div className="d-flex justify-content-between align-items-center mb-2">
                            <small className="text-muted">{`Question ${currentQuestionIndex + 1} of ${surveyQuestions.length}`}</small>
                            <small className="font-italic text-info">
                                {Math.round(((currentQuestionIndex + 1) / surveyQuestions.length) * 100)}% completed
                            </small>
                        </div>
                        <CProgress
                            animated
                            value={((currentQuestionIndex + 1) / surveyQuestions.length) * 100}
                            color="info"
                            style={{ height: '6px', borderRadius: '4px' }}
                        />
                    </div>

                    <CCard className="survey-question-card shadow-sm border-0 rounded-lg">
                        <CCardBody>
                            <h5 className="survey-question-text mb-3 font-weight-semibold">
                                {currentQuestion.Question}
                            </h5>

                            <div className="d-flex flex-column gap-2">
                                {currentQuestion.OptionTypes === 'radio' && options.map((opt, idx) => (
                                    <div
                                        key={idx}
                                        className={`px-2 py-2 border rounded d-flex align-items-center option-card 
                    ${candidateAnswers[currentQuestion.id] === opt ? 'selected' : ''}`}
                                        style={{ cursor: 'pointer', transition: '0.2s', fontSize: '0.9rem' }}
                                        onClick={() => this.handleAnswerChange(currentQuestion.id, 'radio', opt)}
                                    >
                                        <input
                                            type="radio"
                                            name={`q-${currentQuestion.id}`}
                                            value={opt}
                                            checked={candidateAnswers[currentQuestion.id] === opt}
                                            onChange={(e) => this.handleAnswerChange(currentQuestion.id, 'radio', e.target.value)}
                                            className="mr-2"
                                        />
                                        {opt}
                                    </div>
                                ))}

                                {currentQuestion.OptionTypes === 'checkbox' && options.map((opt, idx) => {
                                    const currentSelection = candidateAnswers[currentQuestion.id] || [];
                                    const isSelected = currentSelection.includes(opt);
                                    return (
                                        <div
                                            key={idx}
                                            className={`px-2 py-2 border rounded d-flex align-items-center option-card 
                      ${isSelected ? 'bg-success text-white' : 'bg-light'}`}
                                            style={{ cursor: 'pointer', transition: '0.2s', fontSize: '0.9rem' }}
                                            onClick={() => this.handleAnswerChange(currentQuestion.id, 'checkbox', opt)}
                                        >
                                            <input
                                                type="checkbox"
                                                value={opt}
                                                checked={isSelected}
                                                onChange={(e) => this.handleAnswerChange(currentQuestion.id, 'checkbox', e.target.value)}
                                                className="mr-2"
                                            />
                                            {opt}
                                        </div>
                                    );
                                })}

                                {currentQuestion.OptionTypes === 'descriptive' && (
                                    <CTextarea
                                        rows="4"
                                        className="survey-textarea border rounded-lg shadow-sm"
                                        value={candidateAnswers[currentQuestion.id] || ""}
                                        onChange={(e) => this.handleAnswerChange(currentQuestion.id, 'descriptive', e.target.value)}
                                        placeholder="Type your answer here..."
                                    />
                                )}
                            </div>
                        </CCardBody>
                    </CCard>
                </CModalBody>

                <CModalFooter
                    className="custom-modal-footer"
                // className="survey-modal-footer"
                >
                    <CButton color="secondary"
                        disabled={currentQuestionIndex === 0}
                        onClick={this.handlePrevQuestion}
                        style={{ display: 'flex', align_items: 'center', gap: '5px', color: 'white', borderColor: 'white' }}
                    >
                        &larr; Previous
                    </CButton>
                    {currentQuestionIndex < surveyQuestions.length - 1 ? (
                        <CButton color="primary" onClick={this.handleNextQuestion}>
                            Next <CIcon name="cil-arrow-right" className="ml-1" />
                        </CButton>
                    ) : (
                        <CButton color="success" onClick={this.handleFinishSurvey}>
                            <CIcon name="cil-check-circle" className="mr-1" /> Finish
                        </CButton>
                    )}
                </CModalFooter>
            </CModal>
        );
    }

    renderConfirmationModal() {
        const { confirmationModal, existingApplicationInfo } = this.state;
        if (!confirmationModal || !existingApplicationInfo) return null;

        return (
            <CModal show={confirmationModal}
                backdrop={false}
                closeOnBackdrop={false} onClose={() => { this.setState({ confirmationModal: false }); this.refreshRecruitmentList(); }} color="warning">
                <CModalHeader closeButton >
                    <CModalTitle>Active Application Found</CModalTitle>
                </CModalHeader>
                <CModalBody>
                    <p>Our records show you have an active application for the following role:</p>
                    <p><strong>{existingApplicationInfo.roleTitle}</strong></p>
                    <p>Would you like to withdraw that application and proceed with applying for this new role?</p>
                </CModalBody>
                <CModalFooter>
                    <CButton color="secondary" onClick={() => { this.setState({ confirmationModal: false, existingApplicationInfo: null }); this.refreshRecruitmentList(); }}>
                        Cancel
                    </CButton>
                    <CButton color="warning" onClick={this.handleProceedWithNewApplication}>
                        Yes, Withdraw and Apply
                    </CButton>
                </CModalFooter>
            </CModal>
        );
    }

    handleBreadcrumbClick = (path) => {
        this.props.history.push(path);
    };

    toggleEmbedModal = () => {
        this.setState({ embedModal: !this.state.embedModal });
        this.refreshRecruitmentList();
    }

    handleCopyEmbedCode = () => {
        const hid = localStorage.getItem("hospitalCode").toString();
        const currentStaffId = localStorage.getItem("Staffid");

        const staffList = this.props.hrstaffbasicinformationList || [];
        const currentStaff = staffList.find(s => String(s.Staffid) === String(currentStaffId));

        let userSuffix = "";

        if (currentStaff) {
            const cleanPhone = (currentStaff.Phone || "0000000000").replace(/[^0-9]/g, '');
            const rawDob = currentStaff.DateOfBirth || "00000000";
            const cleanDob = rawDob.replace(/[^0-9]/g, '');
            userSuffix = `${cleanPhone}${cleanDob}`;
        } else {
            userSuffix = "000000000000000000";
            console.warn("Current logged-in staff details not found in list.");
        }

        const compositeId = `${hid}${userSuffix}`;
        const embedUrl = `${window.location.origin}/#/standalone/job-listing/${compositeId}`;
        const embedCode = `<iframe src="${embedUrl}" width="100%" height="600px" style="border:none;"></iframe>`;

        navigator.clipboard.writeText(embedCode).then(() => {
            this.setState({ message: "Embed code copied to clipboard!", messageAlert: true, embedModal: false });
        }).catch(err => {
            console.error('Failed to copy: ', err);
            this.setState({ message: "Failed to copy code.", messageAlert: true, embedModal: false });
        });
    }

    toggleActionModal = (modalName) => {
        this.setState(prevState => ({ [modalName]: !prevState[modalName] }));
    }

    getFilteredEvents = () => {
        const { notificationList } = this.props;
        const currentHid = this.getHospitalId();

        if (!notificationList || notificationList.length === 0) return [];

        const hospitalSpecificEvents = notificationList.filter(n => n.hospitalID && n.hospitalID.toString() === currentHid);

        if (hospitalSpecificEvents.length > 0) {
            return hospitalSpecificEvents;
        } else {
            return notificationList.filter(n => n.hospitalID === '0' || n.hospitalID === 0 || n.hospitalID === null);
        }
    };

    processAutomatedEmail = async (candidateData, jobData) => {
        const { setupHRTemplateList, notificationList, emailList } = this.props;
        const hid = this.getHospitalId();

        if (!jobData || !jobData.EmailTemplates) return;

        const rawTemplateIds = jobData.EmailTemplates.split(',').map(item => {
            const match = item.match(/\(([^)]+)\)/);
            return match ? match[1] : null;
        }).filter(id => id);

        if (rawTemplateIds.length === 0) return;

        const selectedTemplates = rawTemplateIds.map(idString => {
            let template = null;

            if (idString.startsWith('sys_')) {
                const cleanId = idString.split('_')[1];
                const notif = (notificationList || []).find(n =>
                    (n.id || n.Id || n.ID)?.toString() === cleanId?.toString()
                );

                if (notif) {
                    template = {
                        id: idString,
                        TempTitle: notif.EmailSubject || notif.Subject || notif.Event,
                        TempBody: notif.EmailBody || notif.Message || "",
                        Type: "System"
                    };
                }
            } else if (idString.startsWith('cus_')) {
                const cleanId = idString.split('_')[1];
                const temp = (setupHRTemplateList || []).find(t =>
                    (t.id || t.Id)?.toString() === cleanId?.toString()
                );

                if (temp) {
                    template = {
                        id: idString,
                        TempTitle: temp.TempTitle,
                        TempBody: temp.TempBody,
                        Type: "Custom"
                    };
                }
            }
            return template;
        }).filter(t => t);

        const validSender = (emailList || []).find(email =>
            String(email.hid) === hid && (email.is_enabled === 1 || email.is_enabled === "1" || email.is_enabled === true)
        );
        const senderEmail = validSender ? validSender.smtp_user : "";

        if (!senderEmail) {
            console.warn("Auto-Email: No valid sender email found.");
            return;
        }

        const currentDate = new Date().toLocaleDateString();
        const portalUrl = window.location.origin;
        const phone = candidateData.Phone || candidateData.phone || "";

        const replacements = {
            '{CandidateName}': candidateData.Name,
            '{JobTitle}': jobData.Title,
            '{JobPosition}': jobData.JobPosition,
            '{Email}': candidateData.email,
            '{Phone}': phone,
            '{{username}}': phone,
            '{{password}}': phone,
            '{{url}}': portalUrl
        };

        for (const template of selectedTemplates) {
            let subject = template.TempTitle || "Application Update";
            let body = template.TempBody || "";

            Object.keys(replacements).forEach(key => {
                const regex = new RegExp(key.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'), 'g');
                subject = subject.replace(regex, replacements[key]);
                body = body.replace(regex, replacements[key]);
            });

            try {
                const sendPayload = new FormData();
                sendPayload.append('hid', hid);
                sendPayload.append('senderEmail', senderEmail);
                sendPayload.append('recipientEmail', candidateData.email);
                sendPayload.append('subject', subject);
                sendPayload.append('body', body);
                sendPayload.append('attachments', JSON.stringify([]));

                await this.props.SendHREmail(sendPayload);

                if (template.Type === "System") {
                    const cleanId = template.id.split('_')[1];
                    const notif = (notificationList || []).find(n => (n.id || n.Id || n.ID)?.toString() === cleanId);

                    if (notif && candidateData.Phone) {
                        const smsPayload = {
                            hid: hid,
                            recipientPhone: candidateData.Phone,
                            eventId: notif.Event,
                            templateData: {
                                patientName: candidateData.Name,
                                candidateName: candidateData.Name,
                                doctorName: jobData.Manager || "HR Manager",
                                jobPosition: jobData.JobPosition,
                                title: jobData.Title
                            }
                        };
                        await this.props.SendSMS(JSON.stringify(smsPayload));
                    }
                }

                const recordPayload = new FormData();
                recordPayload.append('hid', hid);
                recordPayload.append('cid', candidateData.id);
                recordPayload.append('Reqid', jobData.id);
                recordPayload.append('From', senderEmail);
                recordPayload.append('To', candidateData.email);
                recordPayload.append('Subject', subject);
                recordPayload.append('Templateid', template.id);
                recordPayload.append('TemplateName', template.TempTitle);
                recordPayload.append('Message', body);

                await this.props.createHRRecruitmentCandidateEmail(recordPayload);
            } catch (err) {
                console.error("Error in individual email process:", err);
            }
        }
    }

    getJobDateStatus = (job) => {
        if (!job.StartDate || !job.EndDate) return 'active';

        const today = new Date();
        today.setHours(0, 0, 0, 0);

        const start = new Date(job.StartDate);
        start.setHours(0, 0, 0, 0);

        const end = new Date(job.EndDate);
        end.setHours(0, 0, 0, 0);

        if (today.getTime() > end.getTime()) return 'expired';
        if (today.getTime() < start.getTime()) return 'upcoming';

        return 'active';
    };

    validateEmail = (email) => {
        const re = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
        return re.test(String(email).toLowerCase());
    };

    handlePhoneChange = (e) => {
        const val = e.target.value.replace(/\D/g, "").slice(0, 10);
        this.handleInputChange('phone', val);

        let errorMsg = "";
        if (val.length > 0 && val.length < 10) {
            errorMsg = "Phone number must be exactly 10 digits.";
        } else if (val.length === 10) {
            const { userGetData = [], hrstaffbasicinformationList = [], HRRecruitmentCandidateList = [] } = this.props;
            const cleanPhone = val.trim();
            const hid = this.getHospitalId();

            const phoneExistsInUserTable = (userGetData || []).some(u => {
                const userPhone = u.mobile ? u.mobile.replace(/\D/g, '').trim() : '';
                return userPhone && userPhone.slice(-10) === cleanPhone.slice(-10) && String(u.hospitalID) === String(hid);
            });

            const phoneExistsInStaffTable = (hrstaffbasicinformationList || []).some(s => {
                const staffPhone = s.Phone ? s.Phone.replace(/\D/g, '').trim() : '';
                return staffPhone && staffPhone.slice(-10) === cleanPhone.slice(-10) && String(s.hid) === String(hid);
            });

            const phoneExistsInCandidateTable = (HRRecruitmentCandidateList || []).some(c => {
                const candidatePhone = c.Phone ? c.Phone.toString().replace(/\D/g, '').trim() : '';
                return candidatePhone && candidatePhone.slice(-10) === cleanPhone.slice(-10) && String(c.hid) === String(hid);
            });

            if (phoneExistsInUserTable || phoneExistsInStaffTable || phoneExistsInCandidateTable) {
                errorMsg = "Phone number already exists, change phone!";
            }
        }
        this.setState({ phoneValidationError: errorMsg });
    };

    handleEmailChange = (e) => {
        const val = e.target.value;
        this.handleInputChange('email', val);

        let errorMsg = "";
        if (val && !this.validateEmail(val)) {
            errorMsg = "Please enter a valid email address.";
        } else if (val) {
            const { userGetData = [], hrstaffbasicinformationList = [], HRRecruitmentCandidateList = [] } = this.props;
            const cleanEmail = val.trim().toLowerCase();
            const hid = this.getHospitalId();

            const emailExistsInUserTable = (userGetData || []).some(u =>
                u.email && u.email.toLowerCase().trim() === cleanEmail && String(u.hospitalID) === String(hid)
            );

            const emailExistsInStaffTable = (hrstaffbasicinformationList || []).some(s =>
                s.EmailId && s.EmailId.toLowerCase().trim() === cleanEmail && String(s.hid) === String(hid)
            );

            const emailExistsInCandidateTable = (HRRecruitmentCandidateList || []).some(c =>
                c.email && c.email.toLowerCase().trim() === cleanEmail && String(c.hid) === String(hid)
            );
        }
        this.setState({ emailValidationError: errorMsg });
    };


    render() {
        const { HRRecruitmentMainList, HRRecruitmentInfoList } = this.props;
        const { loadingMessage, isLoading } = this.state;

        // Use the prop passed from RecruitmentHub, fallback to state if not provided
        const searchQuery = this.props.searchQuery !== undefined ? this.props.searchQuery : this.state.searchQuery;

        const hospitalCode = this.getHospitalId();
        const isWidgetMode = this.props.match && this.props.match.params && this.props.match.params.hid;
        let displayEmbedCode = "";
        let previewUrl = "";
        let embedUrl = "";

        if (!isWidgetMode) {
            const hid = localStorage.getItem("hospitalCode").toString();
            const currentStaffId = localStorage.getItem("Staffid");

            const staffList = this.props.hrstaffbasicinformationList || [];
            const currentStaff = staffList.find(s => String(s.Staffid) === String(currentStaffId));

            let userSuffix = "000000000000000000";

            if (currentStaff) {
                const cleanPhone = (currentStaff.Phone || "0000000000").replace(/[^0-9]/g, '');
                const cleanDob = (currentStaff.DateOfBirth || "00000000").replace(/[^0-9]/g, '');
                userSuffix = `${cleanPhone}${cleanDob}`;
            }

            const compositeId = `${hid}${userSuffix}`;
            embedUrl = `${window.location.origin}/#/standalone/job-listing/${compositeId}`;
            previewUrl = embedUrl;
            displayEmbedCode = `<iframe src="${previewUrl}" width="100%" height="600px" style="border:none;"></iframe>`;
        }

        const openJobListings = (HRRecruitmentMainList || []).filter(job =>
            job.isPublished === 'Yes' &&
            job.ProcessType === 'Recruitment' &&
            job.hid?.toString() === hospitalCode
        ).sort((a, b) => b.id - a.id);

        const filteredJobListings = openJobListings.filter(job =>
            (job.Title && job.Title.toLowerCase().includes(searchQuery.toLowerCase())) ||
            (job.JobPosition && job.JobPosition.toLowerCase().includes(searchQuery.toLowerCase()))
        );

        return (
            <>
                <GlobalLoader isLoading={isLoading} message={loadingMessage} />

                {this.renderDetailsModal()}
                {this.renderApplyModal()}
                {this.renderSurveyModal()}
                {this.renderConfirmationModal()}

                {/* --- Message Modal for alerts --- */}
                <CModal show={this.state.messageAlert}
                    backdrop={false}
                    closeOnBackdrop={false}
                    onClose={() => this.setState({ messageAlert: false })} size="sm"
                    className="modal-alert-on-top"
                    style={{ zIndex: 9999 }}
                >
                    <style>{`
                        .modal-alert-on-top {
                            z-index: 9999 !important;
                        }
                    `}</style>
                    <CModalHeader closeButton style={{ backgroundColor: '#303c54f3', color: 'white' }}><CModalTitle>Notification</CModalTitle></CModalHeader>
                    <CModalBody>{this.state.message}</CModalBody>
                    <CModalFooter className="custom-modal-footer">
                        <CButton color="primary"
                            onClick={() => { this.setState({ messageAlert: false }); this.refreshRecruitmentList(); }}
                        >Ok</CButton>
                    </CModalFooter>
                </CModal>
                <CModal
                    show={this.state.embedModal}
                    onClose={this.toggleEmbedModal}
                    size="lg"
                    backdrop={false} closeOnBackdrop={false}
                >
                    <CModalHeader closeButton style={{ backgroundColor: '#303c54f3', color: 'white' }}>
                        <CModalTitle>Website Widget Integration</CModalTitle>
                    </CModalHeader>
                    <CModalBody>
                        <p className="text-muted">Copy the code below and paste it into your website's HTML to display your job listings.</p>
                        <div className="d-flex">
                            <CInput
                                type="text"
                                value={displayEmbedCode}
                                readOnly
                                style={{ backgroundColor: '#f8f9fa', fontFamily: 'monospace', fontSize: '0.85rem' }}
                            />
                            <CButton
                                color="secondary"
                                className="ml-2"
                                onClick={this.handleCopyEmbedCode}
                            >
                                Copy
                            </CButton>
                        </div>
                        <div className="mt-3">
                            <small className="text-muted">
                                <strong>Preview Link:</strong> <a href={embedUrl} target="_blank" rel="noopener noreferrer">{embedUrl}</a>
                            </small>
                        </div>
                    </CModalBody>
                    <CModalFooter>
                        <CButton color="secondary" onClick={this.toggleEmbedModal}>Close</CButton>
                    </CModalFooter>
                </CModal>

                {/* Common style definition injecting drawer layouts, animations, transitions, and backdrop blur effects */}
                <style>{`
                    .drawer-overlay {
                        position: fixed;
                        top: 0;
                        left: 0;
                        width: 100vw;
                        height: 100vh;
                        background-color: rgba(0, 0, 0, 0.45);
                        backdrop-filter: blur(8px) !important;
                        transition: opacity 0.3s ease-in-out, visibility 0.3s ease-in-out;
                        opacity: 0;
                        visibility: hidden;
                        z-index: 1050;
                    }
                    .drawer-overlay.show {
                        opacity: 1;
                        visibility: visible;
                    }
                    .side-drawer {
                        position: fixed;
                        top: 0;
                        right: -900px; 
                        width: 860px; 
                        height: 100vh;
                        background-color: #fff;
                        box-shadow: -4px 0 15px rgba(0,0,0,0.15);
                        transition: right 0.3s ease-in-out;
                        z-index: 1051;
                        display: flex;
                        flex-direction: column;
                    }
                    .side-drawer.show {
                        right: 0;
                    }
                    .drawer-header {
                        background-color: #303c54;
                        color: #fff;
                        padding: 15px 20px;
                        display: flex;
                        align-items: center;
                        justify-content: space-between;
                    }
                    .drawer-body {
                        flex: 1;
                        overflow-y: auto;
                        background-color: #f8f9fa;
                    }
                    .drawer-footer {
                        padding: 15px 20px;
                        background-color: #f0f3f5;
                        border-top: 1px solid #dee2e6;
                        text-align: right;
                    }
                    .profile-detail-row {
                        padding: 8px 0;
                        border-bottom: 1px dashed #e2e8f0;
                        font-size: 14px;
                    }
                    .profile-detail-label {
                        font-weight: 600;
                        color: #4a5568;
                    }
                    .profile-detail-value {
                        color: #2d3748;
                    }
                    .gc-table-container label {
                        color: #4f5d73 !important;
                        font-weight: 500 !important;
                        font-size: 0.875rem !important;
                    }
                    .gc-table-container .form-control {
                        color: #4f5d73 !important;
                        font-size: 0.875rem !important;
                    }
                    .gc-table-container .form-control::placeholder {
                        color: #8a93a2 !important;
                        opacity: 1;
                    }
                `}</style>

                {/* Parent container styled transparently so cards render cleanly over RecruitmentHub gray background */}
                <div style={{ background: "transparent" }}>

                    {/* Job Openings List Card */}
                    <CCard className="border-0 shadow-sm" style={{ border: "1px solid #e1e4e8", borderRadius: "8px", boxShadow: "0 1px 3px rgba(0,0,0,0.05)" }}>
                        <CCardHeader className={"Mmarketing-subheader"}>
                            <CRow className="align-items-center">
                                <CCol>
                                    <strong className="mb-0">Job Openings</strong>
                                </CCol>
                                {!isWidgetMode && (
                                    <div className="ml-auto mr-3">
                                        <CButton
                                            color="dark"
                                            variant="outline"
                                            // size="sm"
                                            onClick={this.toggleEmbedModal}
                                            className="d-flex align-items-center"
                                        >
                                            &lt;/&gt; Embed Widget
                                        </CButton>
                                    </div>
                                )}
                            </CRow>
                        </CCardHeader>
                        <CCardBody style={{ backgroundColor: '#fff', padding: '1.5rem', borderBottomLeftRadius: "8px", borderBottomRightRadius: "8px" }}>
                            <CRow className="mb-4">
                                <CCol className="text-center">
                                    <h1 className="job-listing-title" style={{ fontSize: '1.75rem', color: '#333' }}>Find Your Next Opportunity</h1>
                                    <p className="text-muted">Browse our current openings and find a role that’s right for you.</p>
                                </CCol>
                            </CRow>

                            <div className="recruitment-grid-container"
                                style={{
                                    display: 'grid',
                                    gridTemplateColumns: 'repeat(auto-fill, minmax(300px, 1fr))',
                                    gap: '1.5rem',
                                    paddingBottom: '20px'
                                }}
                            >
                                {filteredJobListings.length > 0 ? filteredJobListings.map(job => {
                                    const applicantCount = (HRRecruitmentInfoList || []).filter(
                                        c => String(c.Reqid) === String(job.id)
                                    ).length;
                                    const progress = (applicantCount / job.Vacancy) * 100;
                                    const dateStatus = this.getJobDateStatus(job);
                                    let finalStatus = 'active';
                                    if (job.Status === 'On Hold') {
                                        finalStatus = 'on_hold';
                                    } else if (job.Status === 'Closed') {
                                        finalStatus = 'expired';
                                    } else {
                                        finalStatus = dateStatus;
                                    }

                                    const isApplyDisabled = finalStatus !== 'active';

                                    let badge = null;
                                    let btnText = "Apply";

                                    if (finalStatus === 'on_hold') {
                                        badge = <CBadge color="warning" shape="pill" className="float-right">On Hold</CBadge>;
                                        btnText = "On Hold";
                                    } else if (finalStatus === 'expired') {
                                        badge = <CBadge color="danger" shape="pill" className="float-right">Closed</CBadge>;
                                        btnText = "Closed";
                                    } else if (finalStatus === 'upcoming') {
                                        badge = <CBadge color="info" shape="pill" className="float-right">Upcoming</CBadge>;
                                        btnText = "Soon";
                                    }

                                    return (
                                        <div key={job.id} className="recruitment-card"
                                            style={{
                                                cursor: 'default',
                                                width: '100%',
                                                minWidth: '0',
                                                opacity: finalStatus === 'active' ? 1 : 0.85
                                            }}
                                        >
                                            <CCardBody className="d-flex flex-column h-100">

                                                <div className="d-flex justify-content-between align-items-start">
                                                    <h6 className="company-name">{job.Company || 'In-House'}</h6>
                                                    <CButton color="primary"
                                                        variant="outline"
                                                        // size="sm"
                                                        disabled={isApplyDisabled}
                                                        onClick={() => this.toggleApplyModal(job)}>
                                                        {btnText}
                                                    </CButton>
                                                </div>

                                                <div className="d-flex justify-content-between align-items-center mt-2">
                                                    <h5 className="job-title mb-0">{job.Title}</h5>
                                                    {badge}
                                                </div>
                                                <p className="job-position text-muted mb-3">{job.JobPosition}</p>

                                                <div className="mt-auto">
                                                    <div className="d-flex justify-content-between text-muted small mb-1">
                                                        <span>Applicants: {applicantCount}</span>
                                                        <span>Vacancy: {job.Vacancy}</span>
                                                    </div>
                                                    <CProgress value={progress} color="success" style={{ height: '8px' }} />
                                                    <div className="text-muted small mt-2">
                                                        Ends: {new Date(job.EndDate).toLocaleDateString()}
                                                    </div>
                                                </div>

                                                <div className="text-center mt-4">
                                                    <CButton color="dark" variant="ghost" onClick={() => this.toggleDetailsModal(job)}>
                                                        View Details
                                                    </CButton>
                                                </div>
                                            </CCardBody>
                                        </div>
                                    );
                                }) : (
                                    <div className="empty-state-container">
                                        <CIcon name="cil-moon" size="3xl" />
                                        <h5 className="empty-state-title mt-2">No Openings Found</h5>
                                        <p className="empty-state-text">There are currently no open positions. Please check back later!</p>
                                    </div>
                                )}
                            </div>
                        </CCardBody>
                    </CCard>
                </div>
            </>
        );
    }
}

const mapStateToProps = (state) => ({
    emailList: state.setupsettingReducer.emailList,
    notificationList: state.setupsettingReducer.notificationList,
    setupHRTemplateList: state.setuphospitalehrsettingReducer.setupHRTemplateList,
    HRRecruitmentMainList: state.setuphrstaffbasicinformationReducer.HRRecruitmentMainList,
    HRRecruitmentInfoList: state.setuphrstaffbasicinformationReducer.HRRecruitmentInfoList,
    HRRecruitmentCandidateList: state.setuphrstaffbasicinformationReducer.HRRecruitmentCandidateList,
    HRRecruitmentCandidateResumeList: state.setuphrstaffbasicinformationReducer.HRRecruitmentCandidateResumeList,
    setupHRSurveyTemplateList: state.setuphospitalehrsettingReducer.setupHRSurveyTemplateList,
    hrstaffbasicinformationList: state.setuphrstaffbasicinformationReducer.hrstaffbasicinformationList,
    userGetData: state.loginReducer.userGetData,
});

export default connect(mapStateToProps, {
    getUser,
    getHRStaff,
    getEmail,
    getNotification,
    SendHREmail,
    createHREmail,
    SendSMS,
    createHRRecruitmentCandidateEmail,
    getHRRecruitmentMain,
    getHRRecruitmentCandidate,
    getHRRecruitmentInfo,
    createHRRecruitmentCandidate,
    updateHRRecruitmentCandidate,
    createHRRecruitmentCandidateResume,
    updateHRRecruitmentCandidateResume,
    getHRRecruitmentCandidateResume,
    deleteHRRecruitmentCandidateResume,
    updateHRRecruitmentInfo,
    createHRRecruitmentInfo,
    deleteHRRecruitmentInfo,
    getsetupHrSurveyTemplate,
    createHRRecruitmentSurveyResponse,
    getsetupHrTemplate,
})(JobListing);